module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0001.jpg?v=a375c30c";